"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_ADDRESS_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.STORE_ADDRESS_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment StoreAddress on Address {\n    address1\n    address2\n    city\n    state\n    postalCode\n  }\n"], ["\n  fragment StoreAddress on Address {\n    address1\n    address2\n    city\n    state\n    postalCode\n  }\n"])));
var templateObject_1;
